import { ReactNode, createContext, useContext } from 'react';

import { ReportDetailProps } from '../types';

export interface ReportDetailContextValue extends ReportDetailProps {}

export const ReportDetailContext = createContext<ReportDetailContextValue>({});

export interface ReportDetailProviderProps extends ReportDetailProps {
  children: ReactNode;
}

export const ReportDetailProvider = (props: ReportDetailProviderProps) => {
  const { children, data } = props;

  return <ReportDetailContext.Provider value={{ data }}>{children}</ReportDetailContext.Provider>;
};

export const useReportDetailContext = () => useContext(ReportDetailContext);
